import React, { FC } from "react";

import { Icon } from "../index";

import styles from "./index.module.css";

type LoadingProps = {
  title?: string;
};

const Loading: FC<LoadingProps> = (props) => {
  const { title } = props;
  return (
    <div className={styles.container}>
      <Icon name="Loading" color="secondary" size={50} />
      {title && <div className={styles.title}>{title}</div>}
    </div>
  );
};

export default Loading;
